import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Button, Card, Descriptions, Image, Input, Popconfirm, Space, Switch, Table, Tag, Tooltip, } from 'antd'
import '../../style/page.css'
import { EyeIcon, SearchIcon, TrashIcon, } from 'lucide-react';
import Tables from '../../component/Tables';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSubscription, editSubscriptionStatus, getSubscription, setPagination, setSearchParams } from '../../feature/subscription/subscriptionSlice';
import AddSubscription from './AddSubscription';
import EditSubscription from './EditSubscription';

function SubscriptionList() {
    const [value, setValue] = useState("");
    const [loadingId, setLoadingId] = useState(null);

    const dispatch = useDispatch()
    const { subscriptionList, isLoading, totalPage, limit, current, searchParams } = useSelector((state) => state.subscriptions);

    const columns = [
        {
            title: 'Plan Name',
            dataIndex: 'planName',
            key: 'planName',
            ellipsis: true,


        },
        {
            title: 'Duration (Months)',
            dataIndex: 'durationInMonths',
            key: 'durationInMonths',
            ellipsis: true,


        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            ellipsis: true,
        },
        {
            title: 'No. Of Teachers',
            dataIndex: 'numberOfTeachers',
            key: 'numberOfTeachers',
            ellipsis: true,
        },
        {
            title: 'No. Of Children',
            dataIndex: 'numberOfChildrens',
            key: 'numberOfChildrens',
            ellipsis: true,
        },
        {
            title: 'No. Of Admins',
            dataIndex: 'numberOfAdmins',
            key: 'numberOfAdmins',
            ellipsis: true,
        },

        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,

            render: (description) => (
                <Tooltip title={description}>
                    <span>
                        {description?.length > 20 ? description.substring(0, 20) + "..." : description}
                    </span>
                </Tooltip>
            ),
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            ellipsis: true,
            render: (_, { status }) => <Tag color={status === "ACTIVE" ? "#6BC445" : "#FE7743"} bordered={false}>{status}</Tag>
        },
        {
            title: 'Created At',
            dataIndex: 'addedDate',
            key: 'addedDate',
            ellipsis: true,
        },

        {
            title: 'Action',
            ellipsis: true,
            fixed: "right",
            key: 'action',
            render: (_, {
                _id,
                durationInMonths,
                planName,
                description,
                price,
                status,
                numberOfChildrens, numberOfTeachers, numberOfAdmins
            }) => (
                <Space size="middle">
                    <EditSubscription
                        editData={
                            {
                                _id,
                                durationInMonths,
                                planName,
                                description,
                                price, numberOfChildrens, numberOfTeachers, numberOfAdmins
                            }
                        } />
                    <Popconfirm
                        title="Delete the subscription"
                        description="Are you sure to delete this subscription?"
                        onConfirm={() => handleDelete(_id)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <TrashIcon size={20} />
                    </Popconfirm>
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        checked={status === "ACTIVE"}
                        loading={loadingId === _id}
                        onChange={() => handleActive(_id)}
                    />
                </Space>
            ),
        },
    ];

    const handleActive = async (id) => {
        setLoadingId(id)
        const resultAction = await dispatch(editSubscriptionStatus({ subScriptionId: id }));
        if (editSubscriptionStatus.fulfilled.match(resultAction)) {
            await dispatch(getSubscription({}));
            setLoadingId(null);

        } else {
            console.error("edit status");
            setLoadingId(null);

        }
    };


    const handlePagination = (page) => {
        dispatch(setPagination(page))
    };

    const fetchsubscriptionList = async () => {
        dispatch(getSubscription({ current, limit, searchParams })); // send params if needed
    }

    useEffect(() => {
        fetchsubscriptionList()
    }, [current, searchParams])

    const props = {
        columns, tableData: subscriptionList, current, handlePagination, totalPage, isLoading
    }

    const handleDelete = async (id) => {
        const resultAction = await dispatch(deleteSubscription(id));
        if (deleteSubscription.fulfilled.match(resultAction)) {
            await dispatch(getSubscription({}));
        } else {
            console.error("delete subscription");
        }
    };

    const cancel = e => {
        console.log(e);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }

    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.subscription}</p>
                    <Space>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                        <AddSubscription />
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                <Tables {...props} />
            </div>
        </section >
    )
}

export default SubscriptionList